<template>
  <div>
    <b-row align-h="center" class="mb-2">
      <div id="pa-dimensions">
        <div class="diagram-container">
          <img :src="dimensionsImg" alt="dimensions-img" class="d-none d-md-block">
          <img :src="dimensionsImgLabeled" alt="dimensions-img-labeled" class="d-block d-md-none">

          <div class="motor-selector">
            <div v-if="!controlAcceso.motor_id" class="motor-empty">
              <div class="empty-placeholder">
                <font-awesome-icon :icon="['far', 'image']" size="2x" />
              </div>
            </div>

            <div v-else class="motor-selected">
              <b-img
                v-if="controlAcceso.motor_image_url"
                :src="controlAcceso.motor_image_url"
              />
            </div>
          </div>

          <div class="input locking-devices">
            <ValidationProvider rules="required" name="Cerradura o bloqueos" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Cerradura o </p>
                <p class="mb-0">bloqueos</p>
              </div>
              <b-select
                v-model="detailsForm.locking_devices"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="lockingDevices"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input entry-device-1">
            <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Dispositivo de</p>
                <p class="mb-0">entrada</p>
              </div>
              <b-select
                v-model="detailsForm.entry_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="communicationDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input alerts">
            <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
              <p class="label">Alertas</p>
              <b-select
                v-model="detailsForm.alerts"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="alertsOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-1">
            <ValidationProvider rules="required" name="Dispositivo de emergencia" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Dispositivo de</p>
                <p class="mb-0">emergencia</p>
              </div>
              <b-select
                v-model="detailsForm.exit_device_1"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="emergencyDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>

          <div class="input exit-device-2">
            <ValidationProvider rules="required" name="Dispositivo de salida" style="width: 100%" v-slot="{ valid, errors }">
              <div class="label text-center">
                <p class="mb-0">Dispositivo de</p>
                <p class="mb-0">salida</p>
              </div>
              <b-select
                v-model="detailsForm.exit_device_2"
                :state="errors[0] ? false : (valid ? true : false)"
                :options="exitDevicesOptions"
                size="sm"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </b-row>

    <b-row align-h="center" class="mb-3 px-2">
      <div style="max-width: 600px; width: 100%;">
        <b-button
          v-if="!controlAcceso.motor_id"
          block
          variant="outline-primary"
          class="font-weight-600 px-2 py-1"
          @click="$store.commit('setOpenModalName', 'motorSelector')"
        >
          <font-awesome-icon :icon="['far', 'plus-circle']" class="mr-2" />
          Seleccionar paso rápido
        </b-button>
        <div v-else>
          <div class="motor-info-box">
            <div class="fs-16 d-flex">
              <p class="font-weight-bold mb-0">Modelo:</p>
              <p class="font-weight-600 ml-2">{{ controlAcceso.motor.item_code }}</p>
            </div>
            <p class="fs-16 font-weight-bold mb-0">Descripción</p>
            <div class="motor-description-scroll">
              <p v-if="controlAcceso.motor.description" class="text-muted small motor-description-text mb-0">{{ controlAcceso.motor.description }}</p>
              <p v-else class="text-muted small motor-description-text text-center mb-0">Sin descripción</p>
            </div>
            <div class="d-flex justify-content-center mt-3">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="$store.commit('setOpenModalName', 'motorSelector')"
              >
                Cambiar
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-row>

    <div class="d-block d-md-none px-2">
      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Cerradura o bloqueos" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Cerradura o bloqueos" :blank="detailsForm.locking_devices" show-reset @reset="detailsForm.locking_devices = null" />
            </template>
            <b-select
              v-model="detailsForm.locking_devices"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="lockingDevices"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de entrada" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de entrada" :blank="detailsForm.entry_device_1" show-reset @reset="detailsForm.entry_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.entry_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="communicationDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Alertas" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Alertas" :blank="detailsForm.alerts" show-reset @reset="detailsForm.alerts = null" />
            </template>
            <b-select
              v-model="detailsForm.alerts"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="alertsOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de salida" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de salida" :blank="detailsForm.exit_device_1" show-reset @reset="detailsForm.exit_device_1 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_1"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="emergencyDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>

      <b-row class="mb-2">
        <ValidationProvider rules="required" name="Dispositivo de salida" style="width: 100%" v-slot="{ valid, errors }">
          <b-form-group class="w-100">
            <template #label>
              <Label label="Dispositivo de salida" :blank="detailsForm.exit_device_2" show-reset @reset="detailsForm.exit_device_2 = null" />
            </template>
            <b-select
              v-model="detailsForm.exit_device_2"
              :state="errors[0] ? false : (valid ? true : false)"
              :options="exitDevicesOptions"
            >
            </b-select>
          </b-form-group>
        </ValidationProvider>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider } from 'vee-validate'

import {
  sensorsOptions,
  alertsOptions,
  cerraduraBloqueosOptions,
  emergencyDevicesOptions
} from '../../../../../sharedOptions/controlesAccesoModule'

import Label from '../../Label'
import Button from '../../../../shared/Button'

export default {
  name: 'pasoRapido',
  components: {
    Label,
    Button,
    ValidationProvider
  },
  props: {
    form: Object,
    detailsForm: Object
  },
  data () {
    return {
      dimensionsImg: require('../../../../../../assets/images/control_acceso/layout.png'),
      dimensionsImgLabeled: require('../../../../../../assets/images/control_acceso/layout_labeled.png'),
      entryExitDevicesOptions: [
        { value: null, text: '---Seleccionar---' },
        { value: 'Lector de tarjetas', text: 'Lector de tarjetas' },
        { value: 'App móvil / Bluetooth', text: 'App móvil / Bluetooth' },
        { value: 'Botón', text: 'Botón' },
        { value: 'Especial', text: 'Especial (ver notas)' },
        { value: 'N/A', text: 'N/A' }
      ],
      sensorsOptions: sensorsOptions,
      cerraduraBloqueosOptions: cerraduraBloqueosOptions,
      emergencyDevicesOptions: emergencyDevicesOptions,
      alertsOptions: alertsOptions,
      lockingDevices: [
        { value: null, text: '---Seleccionar---' },
        { value: 'El propio del sistema', text: 'El propio del sistema' },
        { value: 'Elemento adicional (ver notas)', text: 'Elemento adicional (ver notas)' },
        { value: 'N/A', text: 'N/A' }
      ],
      communicationDevicesOptions: [
        { value: null, text: '---Seleccionar---' },
        { value: 'Lector de tarjetas', text: 'Lector de tarjetas' },
        { value: 'Lector QR', text: 'Lector QR' },
        { value: 'Teclado numérico', text: 'Teclado numérico' },
        { value: 'Lector biométrico', text: 'Lector biométrico' },
        { value: 'Entrada libre', text: 'Entrada libre' },
        { value: 'Especial', text: 'Especial (ver notas)' },
        { value: 'N/A', text: 'N/A' }
      ]
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    exitDevicesOptions () {
      return [
        { value: null, text: '---Seleccionar---' },
        { value: 'Lector de tarjetas', text: 'Lector de tarjetas' },
        { value: 'Lector QR', text: 'Lector QR' },
        { value: 'Teclado numérico', text: 'Teclado numérico' },
        { value: 'Lector biométrico', text: 'Lector biométrico' },
        { value: 'Intercomunicador', text: 'Intercomunicador' },
        { value: 'Botón de salida', text: 'Botón de salida' },
        { value: 'Sensor de movimiento REX', text: 'Sensor de movimiento REX' },
        { value: 'Especial', text: 'Especial (ver notas)' },
        { value: 'N/A', text: 'N/A' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
  #pa-dimensions {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .diagram-container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      max-width: 59.5rem;

      img {
        width: 100%;
        height: auto;
        align-self: center;
      }

      .motor-selector {
        position: absolute;
        top: 42%;
        left: 48%;
        transform: translateX(-50%);
        z-index: 8;
        display: flex;
        justify-content: center;
        align-items: center;

        .motor-empty {
          display: flex;
          justify-content: center;
          align-items: center;

          .empty-placeholder {
            width: 124px;
            height: 94px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(255, 255, 255, 0.85);
            border: 2px dashed rgba(0, 102, 204, 0.3);
            color: #9ca3af;
            font-size: 48px;
            backdrop-filter: blur(4px);
          }
        }

        .motor-selected {
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            max-width: 240px;
            width: 100%;
            max-height: 240px;
            height: auto;
            object-fit: contain;
          }
        }
      }
    }

    .input {
      position: absolute;
      z-index: 10;
      min-width: 180px;
      display: flex;
      flex-direction: column;
      gap: 2px;
      background: rgba(255, 255, 255, 0.94);
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      .label {
        display: none;
        font-size: 11px;
        font-weight: 600;
        margin-bottom: 0;
        color: #666;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        line-height: 1.2;
      }
    }

    // Posiciones de inputs
    .locking-devices {
      top: 20%;
      left: 8%;
    }
    .entry-device-1 {
      top: 34%;
      left: 0%;
    }
    .alerts {
      top: 13%;
      right: 42%;
    }
    .exit-device-1 {
      top: 19%;
      right: -2%;
    }
    .exit-device-2 {
      bottom: 34%;
      right: 2%;
    }
  }

  .motor-info-box {
    border: 1px solid #e9ecef;
    padding: 1rem;
    border-radius: 0.25rem;
    background-color: #f8f9fa;
  }

  .motor-description-scroll {
    max-height: 150px;
    overflow-y: auto;
    border-top: 1px solid #e9ecef;
    border-bottom: 1px solid #e9ecef;
    padding: 0.75rem 0;
    margin: 0.75rem 0;
  }

  .motor-description-text {
    text-align: justify;
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    #pa-dimensions {
      .diagram-container {
        .motor-selector {
          .motor-empty {
            .empty-placeholder {
              width: 89px;
              height: 72px;
              font-size: 32px;

              svg {
                font-size: 2.4rem;
              }
            }
          }

          .motor-selected {
            img {
              max-width: 100px;
            }
          }
        }
      }

      .input {
        min-width: 0;
        width: auto;
        padding: 0px;
        border: none;
        background: rgba(255, 255, 255, 0.94);
        box-shadow: none;

        select {
          display: none;
        }

        .label {
          font-size: 8px;
          font-weight: 600;
          color: #333;
          white-space: nowrap;
          letter-spacing: normal;
          margin: 0;
        }

        &:hover {
          border: none;
          transform: none;
        }
      }
      // inputs
      .locking-devices {
        top: 18.5%;
        left: 12%;
      }
      .entry-device-1 {
        top: 35%;
        left: 0%;
      }
      .alerts {
        top: 13%;
        right: 42%;
      }
      .exit-device-1 {
        top: 18%;
        right: 11%;
      }
      .exit-device-2 {
        bottom: 33%;
        right: 10%;
      }
    }
  }
</style>
